import {eventAttributesReducer} from '~/common/event/eventAttributes/reducer';
import {reducer as giftKeywords} from '~/common/gift-keywords/reducer';
import {api as oneStepApi} from '~/OneStepCreateInvitation/api/api';
import {api} from '~/ViewInvitation/api/api';
import {reducer as loginModal} from '~library/organisms/LoginModal/reducer';
import {reducer as avatars} from './avatars';
import {reducer as coverData} from './coverData';
import {reducer as donation} from './donation';
import {reducer as eventDetails} from './eventDetails';
import {reducer as eviteEvent} from './eviteEvent';
import {reducer as fabricDesign} from './fabricDesign';
import {reducer as gifting} from './gifting';
import {reducer as guestList} from './guestList';
import {reducer as moduleOrder} from './moduleOrder';
import {reducer as newMessages} from './newMessages';
import {reducer as photoPosts} from './photoPosts';
import {reducer as photoSummary} from './photoSummary';
import {reducer as photos} from './photos';
import {reducer as poll} from './poll';
import {reducer as posts} from './posts';
import {reducer as premiumDesign} from './premiumDesign';
import {reducer as registry} from './registry';
import {reducer as rsvp} from './rsvp';
import {reducer as user} from './user';
import {reducer as whatToBring} from './whatToBring';
import {reducer as whatToBringSummary} from './whatToBringSummary';

export const rootReducer = {
  [api.reducerPath]: api.reducer,
  [oneStepApi.reducerPath]: oneStepApi.reducer,
  eventAttributes: eventAttributesReducer,
  moduleOrder,
  eviteEvent,
  eventDetails,
  gifting,
  whatToBringSummary,
  whatToBring,
  donation,
  poll,
  user,
  guestList,
  photoPosts,
  photoSummary,
  photos,
  posts,
  avatars,
  rsvp,
  coverData,
  registry,
  newMessages,
  giftKeywords,
  premiumDesign,
  fabricDesign,
  loginModal,
};
